import { CurrencyPipe } from "@angular/common";
import { NgModule } from "@angular/core";
import { AddressPipe } from "./address.pipe";
import { DateConversionPipe } from "./dateConversion.pipe";
import { DateIncrementConvertPipe } from "./dateIncrementConvert.pipe";
import { DatePlaceConversionPipe } from "./datePlaceConversion.pipe";
import { DateResumePipe } from "./dateResume.pipe";
import { ImageURLPipe } from "./imageURL.pipe";
import { MetricConversionPipe } from "./metricConversion.pipe";
import { ObjectToArrayPipe } from "./objectToArray.pipe";
import { OrderTotalPipe } from "./order-total.pipe";
import { PriceConversionPipe } from "./price-conversion.pipe";
import { PriceModePipe } from "./price-mode.pipe";
import { PricePipe } from "./price.pipe";
import { ProductPricePipe } from "./product-price.pipe";
import { ProductsInBasketPipe } from "./products-in-basket.pipe";
import { QuantityConversionPipe } from "./quantityConversion.pipe";
import { ReduceTimeStringPipe } from "./reduceTimeString.pipe";
import { SaleTotalPipe } from "./sale-total.pipe";
import { StatusColorPipe } from "./status-color.pipe";
import { SumUpBasketPipe } from "./sumUpBasket.pipe";
import { SumUpProductPipe } from "./sumUpProduct.pipe";
import { UniqueDatesPipe } from "./uniqueDates.pipe";
import { UniquePlacesPipe } from "./uniquePlaces.pipe";

@NgModule({
  declarations: [ProductsInBasketPipe, SumUpBasketPipe, SumUpProductPipe, ObjectToArrayPipe, ImageURLPipe, StatusColorPipe, QuantityConversionPipe, PriceConversionPipe, 
    DateConversionPipe, MetricConversionPipe, DateIncrementConvertPipe, AddressPipe, ReduceTimeStringPipe, DatePlaceConversionPipe, DateResumePipe,
    UniquePlacesPipe, UniqueDatesPipe, ProductPricePipe, PriceModePipe, PriceConversionPipe, PricePipe, OrderTotalPipe, SaleTotalPipe
  ],
  imports: [],
  exports: [ProductsInBasketPipe, SumUpBasketPipe, SumUpProductPipe, ObjectToArrayPipe, ImageURLPipe, StatusColorPipe, QuantityConversionPipe, PriceConversionPipe, 
    DateConversionPipe, MetricConversionPipe, DateIncrementConvertPipe, AddressPipe, ReduceTimeStringPipe, DatePlaceConversionPipe, DateResumePipe,
    UniquePlacesPipe, UniqueDatesPipe, ProductPricePipe, PriceModePipe, PriceConversionPipe, PricePipe, OrderTotalPipe, SaleTotalPipe
  ],
  providers: [CurrencyPipe]
})
export class PipesModule {}
